import HttpClient from "@/api";

const state = {
  courses: [],
  perPage: 15,
  page: 1,
  lastPage: 1,
  total: 0,
  isLoading: false,
  isLoadMoreLoading: false,
  isPageLoaded: false,
};

const mutations = {
  SET_COURSES(store, payload) {
    store.courses = [...store.courses, ...payload.courses];
    store.total = payload.meta.total;
    store.lastPage = payload.meta.last_page;
  },
  RESET_COURSES(store) {
    store.courses = [];
    store.page = 1;
    store.lastPage = 1;
    store.total = 0;
    store.isLoading = false;
    store.isLoadMoreLoading = false;
    store.isPageLoaded = false;
  },

  TOGGLE_LOADING(store, payload) {
    store.isLoading = payload ?? !store.isLoading;
  },

  TOGGLE_LOAD_MORE_LOADING(store, payload) {
    store.isLoadMoreLoading = payload ?? !store.isLoadMoreLoading;
  },

  TOGGLE_PAGE_LOADING(store) {
    store.isPageLoaded = true;
  },
};

const actions = {
  async loadCourses(store, payload) {
    try {
      store.commit("TOGGLE_LOADING", true);
      const params = {
        page: payload.page,
        per_page: store.state.perPage,
      };

      if (payload.searchQuery) {
        params.query = payload.searchQuery;
      }

      const response = await HttpClient.get(`api/courses`, {
        params,
      });
      if (!response.data) {
        throw new Error("No data");
      }
      store.commit("SET_COURSES", {
        courses: response.data.data,
        meta: response.data?.meta,
      });
    } catch (error) {
      console.error(error);
    } finally {
      store.commit("TOGGLE_PAGE_LOADING");
      store.commit("TOGGLE_LOADING", false);
    }
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
